module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep5@2x-68a83fddd622206f64a2b4fd937045a2.png";